import { useState } from "react";
import "./editorialForms.css";

const categories = [
  { id: "electronics", name: "Eletrônicos" },
  { id: "fashion", name: "Moda" },
  { id: "home", name: "Casa" },
  { id: "beauty", name: "Beleza" },
  { id: "toys", name: "Brinquedos" },
  { id: "sports", name: "Esportes" },
  { id: "automotive", name: "Automotivo" },
  { id: "jewelry", name: "Joias" },
  { id: "phones", name: "Celulares" },
  { id: "computers", name: "Computadores" },
];

const currencies = [
  { id: "USD", name: "USD ($)" },
  { id: "BRL", name: "BRL (R$)" },
  { id: "EUR", name: "EUR (€)" },
];

export default function AliExpressForm({ data, onChange }) {
  const [variants, setVariants] = useState(data?.variants || []);

  const handlePriceChange = (field, value) => {
    onChange({
      ...data,
      price: {
        ...data?.price,
        [field]: value,
      },
    });
  };

  const addVariant = () => {
    const newVariants = [...variants, { name: "", options: [] }];
    setVariants(newVariants);
    onChange({ ...data, variants: newVariants });
  };

  const updateVariant = (index, field, value) => {
    const newVariants = [...variants];
    if (field === "options") {
      newVariants[index].options = value.split(",").map((v) => v.trim());
    } else {
      newVariants[index][field] = value;
    }
    setVariants(newVariants);
    onChange({ ...data, variants: newVariants });
  };

  const removeVariant = (index) => {
    const newVariants = variants.filter((_, i) => i !== index);
    setVariants(newVariants);
    onChange({ ...data, variants: newVariants });
  };

  return (
    <div className="editorial_form aliexpress_form">
      <div className="editorial_form_section">
        <label>
          Nome do Produto <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Nome completo do produto"
          value={data?.productName || ""}
          onChange={(e) => onChange({ ...data, productName: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Descrição detalhada do produto..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          rows={3}
          maxLength={3000}
        />
      </div>

      <div className="editorial_form_section">
        <label>
          Preço <span className="required">*</span>
        </label>
        <div className="editorial_form_row">
          <select
            value={data?.price?.currency || "USD"}
            onChange={(e) => handlePriceChange("currency", e.target.value)}
            className="currency_select"
          >
            {currencies.map((curr) => (
              <option key={curr.id} value={curr.id}>
                {curr.name}
              </option>
            ))}
          </select>
          <input
            type="number"
            placeholder="Preço atual"
            value={data?.price?.amount || ""}
            onChange={(e) =>
              handlePriceChange("amount", parseFloat(e.target.value) || 0)
            }
            min="0"
            step="0.01"
          />
          <input
            type="number"
            placeholder="Preço original"
            value={data?.price?.originalPrice || ""}
            onChange={(e) =>
              handlePriceChange("originalPrice", parseFloat(e.target.value) || 0)
            }
            min="0"
            step="0.01"
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Categoria</label>
        <select
          value={data?.category || ""}
          onChange={(e) => onChange({ ...data, category: e.target.value })}
        >
          <option value="">Selecione uma categoria</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_section">
        <label>
          Variantes
          <button
            type="button"
            className="add_variant_btn"
            onClick={addVariant}
          >
            + Adicionar
          </button>
        </label>
        {variants.map((variant, index) => (
          <div key={index} className="variant_row">
            <input
              type="text"
              placeholder="Nome (ex: Cor, Tamanho)"
              value={variant.name}
              onChange={(e) => updateVariant(index, "name", e.target.value)}
            />
            <input
              type="text"
              placeholder="Opções (ex: Preto, Branco, Azul)"
              value={variant.options?.join(", ") || ""}
              onChange={(e) => updateVariant(index, "options", e.target.value)}
            />
            <button
              type="button"
              className="remove_variant_btn"
              onClick={() => removeVariant(index)}
            >
              ✕
            </button>
          </div>
        ))}
      </div>

      <div className="editorial_form_section">
        <label>Informações de Envio</label>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="freeShippingAli"
            checked={data?.shipping?.methods?.[0]?.price === 0}
            onChange={(e) =>
              onChange({
                ...data,
                shipping: {
                  methods: [
                    {
                      name: e.target.checked ? "Frete Grátis" : "Standard",
                      price: e.target.checked ? 0 : 5,
                      days: "15-30 dias",
                    },
                  ],
                },
              })
            }
          />
          <label htmlFor="freeShippingAli">Frete grátis disponível</label>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Loja</label>
        <input
          type="text"
          placeholder="Nome da loja"
          value={data?.store?.name || ""}
          onChange={(e) =>
            onChange({ ...data, store: { ...data?.store, name: e.target.value } })
          }
        />
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
        </svg>
        <span>
          Adicione múltiplas fotos do produto de diferentes ângulos
        </span>
      </div>
    </div>
  );
}
